<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="banco ? update() : create()">
  <div class="form-row">
    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="banco" class="form-control" [placeholder]="'Ingrese el banco'" [disabled]="banco" />
      <label>Banco</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="nombre" class="form-control" [placeholder]="'Ingrese el nombre del banco'" />
      <label>Nombre Banco</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="tipoTarjeta" class="form-control" [placeholder]="'Ingrese el tipo de tarjeta'" />
      <label>Tipo Tarjeta</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="numeroCuenta" class="form-control" [placeholder]="'Ingrese el número de cuenta'" />
      <label>Número Cuenta</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="cuentaContable" class="form-control" [placeholder]="'Ingrese la cuenta contable'" />
      <label>Cuenta Contable</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="number" formControlName="iOrigenMov" class="form-control" [placeholder]="'Ingrese el movement origin'" min="0" />
      <label>Movement Origin</label>
    </div>

    <div class="form-field flex-grow-1">
      <input pInputText type="number" formControlName="iOrigenDisp" class="form-control" [placeholder]="'Ingrese el dispersion origin'" min="0" />
      <label>Dispersion Origin</label>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" (click)="banco ? update() : create()" [disabled]="!form.valid || loading">
      <mat-icon>save</mat-icon>
      {{ banco ? 'Actualizar' : 'Guardar' }}
    </button>
    
    <button *ngIf="banco" mat-flat-button class="btn-search btn-menu" (click)="openCustomizables()" type="button">
      <mat-icon>settings</mat-icon>
      Customizables
    </button>
  </div>
</form>
